// extracted by mini-css-extract-plugin
module.exports = {"blog":"acf-blog_blog__7z2h0","blog__grid":"acf-blog_blog__grid__Flhjk"};